import React, { useEffect, useState } from 'react'
import { FormattedDate, injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Avatar, useTheme, Container, Grid } from '@material-ui/core'
import { caseSelector, registrationLinkSelector } from '../../../../redux/selectors'
import BorderLinearProgress from '../../../../components/ProgressBar'
import ExpandLessIcon from '@material-ui/icons/ExpandMore';
import ExpandMoreIcon from '@material-ui/icons/KeyboardArrowRight';
import { isMobile } from '../../../../utilties/mobileDetector'
import { useWindowDimensions } from '../../../../utilties/useWindowDimensions'
import AppleAppInstall from '../../../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import AndroidAppInstall from '../../../../assets/images/google-play-badge.png'
import { Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { getPatientRegistrationLink } from '../../../../redux/actions'
import { copyToClipBoard } from '../../../../utilties/utilities'


const useStyles = makeStyles((theme) => ({
	gridRoot: {
		paddingBottom: '22px',
		[theme.breakpoints.down('sm')]: {
			paddingBottom: '0',
		}
	},
	titleRoot: {
		textAlign: 'left',
		fontWeight: 'bold',
		width: '100%',
		fontSize: '21px',
		[theme.breakpoints.down('sm')]: {
			display: 'inline',
			marginBottom: '0',
			width: 'calc(100% - 45px)',
		}
	},
	titleCaseContainer: {
		textAlign: 'right',
		width: '100%',
		[theme.breakpoints.down('sm')]: {			
			textAlign: 'left',
		},
	},
	titleCase: {
		display: 'inline-block',
		textAlign: 'left',
		fontWeight: 'bold',
		fontSize: '20px',
		paddingRight: '10px',
        [theme.breakpoints.down('sm')]: {
			width: '100%',
			textAlign: 'left',
			display: 'inline'
		},		
	},
	titleCaseId: {
		display: 'inline-block',
		textAlign: 'right',
		fontSize: '20px',
		[theme.breakpoints.down('sm')]: {			
			textAlign: 'left',
			display: 'inline'
		},		
	},
	caseToggleButton: {
		width: '40px',
		height: '40px',
		position: 'absolute', 
		top: '8px',
		right: '8px',
		margin: '0',
		color: theme.palette.primary.main,
		'& .MuiTouchRipple-root': {
			display: 'none',
		},
		'& svg': {
		  	color: theme.palette.primary.main,
		  	width: '35px',
			height: '35px',
		},
	},
	gridContainerCase: {
		background: '#FFFFFF',
		boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)',
		borderRadius: '8px 8px 0 0',
		padding: '24px 16px 16px',
		position: 'relative',
		[theme.breakpoints.down('sm')]: {
			padding: '16px',
            borderRadius: '8px',
			marginBottom: '24px'
		},	
	},
	gridContainerTeam: {
		background: '#FFFFFF',
		boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)',
		borderRadius: '0 0 8px 8px',
		padding: '16px',
		position: 'relative',
		[theme.breakpoints.down('sm')]: {
            borderRadius: '8px',
			marginBottom: '0'
		},	
	},

	smallText: {
		fontSize: '20px'
	},
	titleText: {
		fontWeight: '700',
		fontSize: '20px'
	},
	contactWrap: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
	},
	avatarWrap: {
		paddingRight: '18px',
		[theme.breakpoints.down('xs')]: {
			paddingRight: '10px',
		},
	},
	separator: {
		background: '#000',
		width: '49px',
		height: '1px',
		margin: '15px 0 25px',
	  },
	aliasName: {
		fontSize: '18px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',
		marginBottom: '24px',
		marginTop: '8px'
	},
	caseDate: {
		fontSize: '16px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',		
	},
	caseDateTitle: {
		fontSize: '13px',
	},
	summaryProgress: {
		marginBottom: '46px'
	},
	summaryProgressCount: {
		fontSize: '16px',
		fontWeight: 'bold',
		display: 'inline',
		marginRight: '5px'
	},
	summaryProgressText: {
		fontSize: '16px',
		display: 'inline'
	},
	manageCaseTeam: {
		flexWrap: 'nowrap',
		marginBottom: '8px',
		alignItems: 'center',
		[theme.breakpoints.down('sm')]: {
			marginTop: '4px',
		},
	},
	manageCaseContact: {
		flexWrap: 'nowrap',
		marginTop: '25px',
		marginBottom: '16px',
		alignItems: 'center'
	},
	teamName: {
		fontSize: '16px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',		
	},
	teamText: {
		fontSize: '16px',
	}
}))

const CaseSummary = ({ intl, data, getRegistrationLink, registrationLink }) => {
	const classes = useStyles()
	const theme = useTheme()

	const { height, width } = useWindowDimensions();
	const [openCase, setOpenCase] = useState((isMobile || width<960) ? false : true);
	const [openTeam, setOpenTeam] = useState((isMobile || width<960) ? true : true);
	const [showAppIcons, setShowAppIcons] = useState(true);
	
	const appStoreUrl = 'https://apps.apple.com/us/app/benchmarc-health/id1635544500'
    const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.incytes.incytespatientmobile'

	useEffect(
		() => {
			getRegistrationLink();
			
			setShowAppIcons(!window.navigator.userAgent.includes('BenchmarcApp'));
		},
		[]
	)

	const toggleCase = () => {
		if (isMobile || width<960) { 
			setOpenCase(!openCase)
		} 
	}
	const toggleTeam = () => {
		if (isMobile || width<960) {
			setOpenTeam(!openTeam)
		}
	}

	const onMailDoctor = () => {
		if (data && data.creatorEmail) window.location.href = `mailto:${data.creatorEmail}`
	}

	const calculateProgress = () => {
		return data.totalSurveys && data.totalSurveysCompleted ? data.totalSurveysCompleted * 100 / data.totalSurveys : 0
	}

	return (
		<Grid data-testid="case-summary" className={classes.gridRoot}>

			<Grid container direction='column' data-testid="case-summary-content" className={classes.gridContainer}>				

				{/* My Case */}
				<Grid container direction='column' data-testid="case-summary-content-case" className={classes.gridContainerCase}>
					<Grid container direction='row' data-testid="case-summary-content" >
						<Grid item sm={6} xs={12} onClick={toggleCase}>
							{(isMobile || width<960) &&
								<Button className={classes.caseToggleButton}>
									{openCase && <ExpandLessIcon /> }
									{!openCase && <ExpandMoreIcon /> }
								</Button>
							}
							<Typography data-testid="case-summary-title" variant='h2' className={classes.titleRoot}>
								{intl.formatMessage({ id: 'app.dashboard.myCase' })}
							</Typography>
							{(openCase || !(isMobile || width<960)) &&
								<div className={classes.separator}></div>
							}

						</Grid>
						{(openCase || !(isMobile || width<960)) &&
							<Grid item sm={6} xs={12} className={classes.titleCaseContainer}>
								<Typography data-testid="case-summary-caseId-title" variant='body1' className={classes.titleCase}>
									{intl.formatMessage({ id: 'app.dashboard.caseId' })}
								</Typography>
								<Typography data-testid="case-summary-caseId-value" variant='body1' className={classes.titleCaseId}>
									{data.caseId}
								</Typography>
							</Grid>
						}
					</Grid>
					{data && (openCase || !(isMobile || width<960)) && <Grid container>
						<Grid item xs={12} data-testid="case-summary-protocol" className={classes.contactWrap}>
							<Typography data-testid="case-summary-protocol-title" variant='h3' className={classes.aliasName}>
								{data.protocolName}
							</Typography>
						</Grid>
						<Grid item xs={6} data-testid="case-summary-commencement-date" className={classes.caseDate}>
							<FormattedDate year='numeric' month='long' day='2-digit' data-testid="case-summary-commencement-date-value" value={data.commencementDate}></FormattedDate>
							<Typography data-testid="case-summary-commencement-date-title" className={classes.caseDateTitle}>
								{intl.formatMessage({ id: 'app.dashboard.commencementDate' })}
							</Typography>
						</Grid>
						<Grid item xs={6} data-testid="case-summary-treatment-date" className={classes.caseDate}>
							<FormattedDate year='numeric' month='long' day='2-digit' data-testid="case-summary-treatment-date-value" value={data.treatmentDate}></FormattedDate>
							<Typography data-testid="case-summary-treatment-date-title" className={classes.caseDateTitle}>
								{intl.formatMessage({ id: 'app.dashboard.treatmentDate' })}
							</Typography>
						</Grid>
						{data && data.totalSurveys && <Grid item xs={12} data-testid="case-summary-progress" className={classes.summaryProgress}>
							<BorderLinearProgress
								aria-label={intl.formatMessage({ id: 'app.dashboard.surveyProgress' })}
								data-testid="case-summary-progress-bar"
								id="ProgressBar"
								variant="determinate" value={calculateProgress()} style={{ width: '100%' }} />
							<label for="ProgressBar">
								<Typography data-testid="case-summary-progress-count" className={classes.summaryProgressCount}>
									{`${data.totalSurveysCompleted ?? 0}/${data.totalSurveys}`}
								</Typography>
								<Typography data-testid="case-summary-progress-title" className={classes.summaryProgressText}>
									{intl.formatMessage({ id: 'app.dashboard.surveyProgress' })}
								</Typography>
							</label>
						</Grid>}
					</Grid>}
				</Grid>

				{/* My Healthcare Team */}
				<Grid container direction='column' data-testid="case-summary-content-case" className={classes.gridContainerTeam}>
					<Grid item xs={12} onClick={toggleTeam}>
						{(isMobile || width<960) &&
							<Button className={classes.caseToggleButton}>
								{openTeam && <ExpandLessIcon /> }
								{!openTeam && <ExpandMoreIcon /> }
							</Button>
						}
						
						<Typography data-testid="manage-case-title" variant='h4' className={classes.titleRoot}>
							{intl.formatMessage({ id: 'app.dashboard.myHealthcareTeam' })}
						</Typography>
						{(openTeam || !(isMobile || width<960)) &&
							<div className={classes.separator}></div>
						}
					</Grid>
					{(openTeam || !(isMobile || width<960)) &&
					<Grid container direction='column'>
						<Grid container data-testid="manage-case-team" className={classes.manageCaseTeam}>
							{data && data.teamLogo &&
								<Grid item className={classes.avatarWrap}>
									<Avatar data-testid="manage-case-team-avatar" alt='' src={data.teamLogo ? data.teamLogo : ''}
										style={{ width: theme.spacing(7), height: theme.spacing(7) }}
									/>
								</Grid>
							}
							<Grid item>
								{data && data.teamName && (
									<Typography data-testid="manage-case-team-name" className={classes.teamName}>{data.teamName}</Typography>
								)}
							</Grid>
						</Grid>
						<Grid item>
							{data && (data.teamStreetAddress || data.teamCity || data.teamState || data.teamCountry || data.teamPostalCode) && (
								<Typography data-testid="manage-case-team-address" className={classes.teamText}>											
									<span style={{ display: 'block' }}>{data.teamStreetAddress}, {data.teamCity}</span>
									<span style={{ display: 'block' }}>{data.teamState}</span>
									<span style={{ display: 'block' }}>{data.teamPostalCode}</span>
									<span style={{ display: 'block' }}>{data.teamCountry}</span>
									<span style={{ display: 'block' }}>{data.teamPhoneNumber}</span>
								</Typography>
							)}
						</Grid>
						<Grid container data-testid="manage-case-contact" className={classes.manageCaseContact}>
							{data && (
								<Grid item className={classes.avatarWrap}>
									{data.creatorImage && (
										<Avatar data-testid="manage-case-contact-avatar" alt='' src={data.creatorImage ? data.creatorImage : ''}
											style={{ width: theme.spacing(7), height: theme.spacing(7) }}
										/>
									)}
								</Grid>
							)}
							{data && (data.creatorFirstName || data.creatorLastName || data.creatorCredentials) && (
								<Grid item data-testid="manage-case-creator">
									<Typography data-testid="manage-case-creator-title" className={classes.teamName}>
										{data.creatorFirstName} {data.creatorLastName}
										{data.creatorCredentials && ', ' + data.creatorCredentials}
									</Typography>
									{/* <Typography data-testid="manage-casecreator-email" className={classes.teamText} onClick={onMailDoctor}>
										{data && data.creatorEmail && data.creatorEmail.length > 200 ? (
											data.creatorEmail.substring(0, 200) + '...'
										) : (
											data.creatorEmail
										)}{' '}
									</Typography> */}
								</Grid>
							)}
						</Grid>

						{showAppIcons &&
						<Grid
							item
							style={{
								paddingTop: '25px'
							}}
						>
							<Grid
								container
								spacing={1}
								alignItems="center"
								style={{flexWrap: 'nowrap'}}
							>
								<Grid
									item
								>
									<Link
										to={{ pathname: appStoreUrl }}
										target="_blank"
										onClick={() => copyToClipBoard(registrationLink)}
									>
										<img
											src={AppleAppInstall}

										>
										</img>
									</Link>
								</Grid>
								<Grid
									item
								>
									<Link
										to={{ pathname: googlePlayUrl }}
										target="_blank"
										onClick={() => copyToClipBoard(registrationLink)}
									>
										<img
											style={{
												width: '140px',
												height: '60px'
											}}
											src={AndroidAppInstall}>
										</img>
									</Link>
								</Grid>
							</Grid>
						</Grid>
						}
					</Grid>
					}
				</Grid>
				
			</Grid>



		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
	data: caseSelector(state),
	registrationLink: registrationLinkSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	getRegistrationLink: () => dispatch(getPatientRegistrationLink())
})
const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(CaseSummary)
